import { Pipe, PipeTransform } from '@angular/core';
import { Checklist } from "../../classes/checklist";

@Pipe({
  name: 'checklistTitleFilter',
  pure: false
})
export class ChecklistTitleFilterPipe implements PipeTransform {

  transform(checklistList: Array<Checklist>, filterValue: string): any {
    if (!checklistList || !filterValue) {
      return checklistList;
    }
    return checklistList.filter(checklist => checklist.name.toLowerCase().indexOf(filterValue.toLowerCase()) !== -1);
  }

}
